import React from "react";
import { Box } from "@mui/material";
import { Hint, Pill, TsButton } from "../../Troubleshooting/TroubleshootingUi";
import {
  WebhookTestOutcome,
  runWebhookTest,
} from "./SiteAboutPageUtils/webhookTest";

const OUTCOME_TONE = {
  delivered: "ok",
  failed: "bad",
  cooldown: "warn",
  error: "bad",
} as const;

const OUTCOME_LABEL = {
  delivered: "Delivered",
  failed: "Failed",
  cooldown: "Wait",
  error: "Not sent",
} as const;

/**
 * Send test for one camera → webhook link (ENG-2832). Sends a sample
 * detection to this link only and shows what the receiver answered.
 */
export const WebhookLinkTestButton = ({
  linkId,
  label,
}: {
  linkId: number;
  label: string;
}) => {
  const [sending, setSending] = React.useState(false);
  const [outcome, setOutcome] = React.useState<WebhookTestOutcome | null>(null);
  const mounted = React.useRef(true);
  React.useEffect(
    () => () => {
      mounted.current = false;
    },
    []
  );

  const send = async () => {
    setSending(true);
    setOutcome(null);
    const result = await runWebhookTest(linkId);
    if (!mounted.current) return;
    setOutcome(result);
    setSending(false);
  };

  return (
    <Box
      sx={{ display: "inline-flex", gap: 1, alignItems: "center" }}
      data-testid={`webhook-link-test-${linkId}`}
    >
      <TsButton
        size="sm"
        variant="quiet"
        disabled={sending}
        aria-label={`Send test to ${label}`}
        onClick={send}
      >
        {sending ? "Sending…" : "Send test"}
      </TsButton>
      {sending && <Hint>Waiting for the receiver…</Hint>}
      {outcome && (
        <>
          <Pill tone={OUTCOME_TONE[outcome.kind]}>
            {OUTCOME_LABEL[outcome.kind]}
          </Pill>
          <Hint>{outcome.message}</Hint>
        </>
      )}
    </Box>
  );
};
